// A dropzone list mixes browser files picked but not yet uploaded (File) with stored
// attachments returned by the backend ({ key, name, size, ... }). Both carry `key` and
// `size`, so only `instanceof File` tells them apart; never check fields or URL text.

export const isLocalFile = (file) => typeof File !== "undefined" && file instanceof File;

export const isStoredAttachment = (file) =>
  !!file && typeof file === "object" && !isLocalFile(file) && !!file.key;

// Index the backend delete endpoint expects: position among stored attachments only.
export const storedAttachmentIndex = (list, file) =>
  (list ?? []).filter(isStoredAttachment).indexOf(file);

export const splitAttachments = (list) => {
  const items = (list ?? []).filter(Boolean);
  return { stored: items.filter(isStoredAttachment), local: items.filter(isLocalFile) };
};
